export enum NAVIGATION_FROM {
  SEARCH_PAGE = "SEARCH_PAGE",
  ARTICLE_PAGE = "ARTICLE_PAGE",
  HOME_PAGE = "HOME_PAGE",
  BRAND_GUIDES = "BRAND_GUIDES",
  RETAILER_GUIDES = "RETAILER_GUIDES",
  BROWSE_ALL_TOPICS = "BROWSE_ALL_TOPICS",
  RECOMMENDED_GUIDES = "RECOMMENDED_GUIDES",
  ABOUT_FAIRE = "ABOUT_FAIRE",
  RELATED_GUIDES = "RELATED_GUIDES",
  POPULAR_RETAILER_GUIDES = "POPULAR_RETAILER_GUIDES",
  POPULAR_BRAND_GUIDES = "POPULAR_BRAND_GUIDES",
  POLICIES_PRIVACY_SECURITY = "POLICIES_PRIVACY_SECURITY",
  SECTION_TOPICS_PAGE = "SECTION_TOPICS_PAGE",
}

export enum SEARCH_SECTION_FROM {
  BANNER = "BANNER",
  HEADER = "HEADER",
  FOOTER = "FOOTER",
  NAV_SEARCH_HEADER = "NAV_SEARCH_HEADER",
  NAV_SEARCH_BANNER = "NAV_SEARCH_BANNER",
  NAV_SEARCH_ARTICLE_ABOVE = "NAV_SEARCH_ARTICLE_ABOVE",
  NAV_SEARCH_SEARCH_RESULT_ABOVE = "NAV_SEARCH_SEARCH_RESULT_ABOVE",
  NAV_SEARCH_POPULAR_GUIDES_ABOVE = "NAV_SEARCH_POPULAR_GUIDES_ABOVE",
  NAV_SEARCH_TOPICS_ABOVE = "NAV_SEARCH_TOPICS_ABOVE",
}

export enum VIEWPORT {
  WEB_DESKTOP = "WEB_DESKTOP",
  WEB_MOBILE = "WEB_MOBILE",
}

export enum EXPERIMENT {
  CONTROL = "CONTROL",
  TREATMENT = "TREATMENT",
}
